import "./footer.css";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import InfoIcon from "@mui/icons-material/Info";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

function Footer() {
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const navigate = useNavigate();
    const [setting, setSetting] = useState(JSON.parse(localStorage.getItem("setting")));
    const [popup, setPopup] = useState(false);
    
    // STATE ĐIỀU KHIỂN ĐÓNG/MỞ KHUNG LIÊN HỆ
    const [isContactOpen, setIsContactOpen] = useState(false);

    useEffect(() => {
        if (localStorage.getItem("setting") !== null && localStorage.getItem("setting") !== "undefined") {
            setSetting(JSON.parse(localStorage.getItem("setting")));
        } else {
            axios.get(`${process.env.REACT_APP_API_URL}/setting/get`, {}).then((res) => {
                setSetting(res.data.data[0]);
            });
        }
    }, []);

    const [isPlaying, setIsPlaying] = useState(false);
    const [audio, setAudio] = useState(null);

    useEffect(() => {
        if (localStorage.getItem("mp3")?.length > 5) {
            setAudio(new Audio(localStorage.getItem("mp3")));
        } else {
            axios.get(`${process.env.REACT_APP_API_URL}/setting/get`, {}).then((res) => {
                setAudio(new Audio(res.data.data[0]?.mp3));
                localStorage.setItem("mp3", res.data.data[0]?.mp3);
            });
        }
        return () => {
            if (audio) {
                audio.pause();
            }
        };
    }, []);

    const toggleAudio = () => {
        if (audio) {
            if (audio.paused) {
                audio.play();
            } else {
                audio.muted = !audio.muted;
            }
            setIsPlaying(!isPlaying);
        }
    };

    return (
        <>
            <style>{`
                .guide-sub-bar ul li::after,
                .guide-sub-bar ul li::before,
                .footer-text-content ul li::after,
                .footer-text-content ul li::before {
                    content: none !important;
                    display: none !important;
                }
#footer {
    background-color: #040911;
    background-color: #2e354d;
    padding: 41px 0 12px;
}
                /* ============================================================ */
                /* WIDGET LIÊN HỆ (CLICK ĐỂ MỞ TỪ BÊN PHẢI MÀN HÌNH)             */
                /* ============================================================ */
                .kimsa-fixed-contact {
                    position: fixed;
                    right: -280px; /* Ẩn panel lúc đầu */
                    top: 50%;
                    transform: translateY(-50%);
                    display: flex;
                    align-items: center;
                    z-index: 999999;
                    transition: right 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
                }
                .kimsa-fixed-contact.open {
                    right: 0px; /* Trượt ra khi click */
                }

                /* Nút TAB LIÊN HỆ */
                .kimsa-contact-tab {
                    background: linear-gradient(180deg, #d8b456 0%, #cba043 100%);
                    color: #fff;
                    padding: 25px 8px;
                    border-radius: 8px 0 0 8px;
                    cursor: pointer;
                    writing-mode: vertical-rl; /* Chữ dọc */
                    font-size: 16px;
                    font-weight: bold;
                    letter-spacing: 2px;
                    text-transform: uppercase;
                    box-shadow: -4px 4px 10px rgba(0,0,0,0.15);
                    user-select: none;
                }

                /* Hộp chứa nội dung liên hệ */
                .kimsa-contact-panel {
                    background: linear-gradient(180deg, #d8b456 0%, #cba043 100%);
                    width: 280px;
                    padding: 25px 20px;
                    box-shadow: -2px 5px 15px rgba(0,0,0,0.2);
                    display: flex;
                    flex-direction: column;
                    gap: 18px;
                    border-radius: 0 0 0 8px;
                }

                /* Item Liên Hệ */
                .kimsa-contact-item {
                    display: flex;
                    align-items: center;
                    gap: 15px;
                    color: #fff;
                    text-decoration: none;
                    transition: 0.2s;
                }
                .kimsa-contact-item:hover {
                    opacity: 0.8;
                    transform: translateX(-3px);
                }
                
                /* Đổi màu icon thành trắng để giống hình mẫu */
                .kimsa-contact-icon {
                    width: 28px;
                    height: 28px;
                    object-fit: contain;
                    filter: brightness(0) invert(1); 
                }

                .kimsa-contact-text {
                    display: flex;
                    flex-direction: column;
                    color: #fff;
                }
                .kimsa-contact-title {
                    font-size: 16px;
                    font-weight: normal;
                }
                .kimsa-contact-desc {
                    font-size: 16px;
                    font-weight: normal;
                    margin-top: 2px;
                }
                
                /* Ẩn cái menu dọc cũ đi vì đã dùng popup mới */
                .side-contact {
                    display: none !important;
                }
            `}</style>

            {/* WIDGET POP-OUT LIÊN HỆ GÓC MÀN HÌNH */}
            <div className={`kimsa-fixed-contact ${isContactOpen ? 'open' : ''}`}>
                <div className="kimsa-contact-tab" onClick={() => setIsContactOpen(!isContactOpen)}>
                    LIÊN HỆ
                </div>
                <div className="kimsa-contact-panel">
                    
                    {/* LiveChat */}
                    <a href="https://secure.livechatinc.com/licence/19707399/v2/open_chat.cgi" target="_blank" rel="noreferrer" className="kimsa-contact-item">
                        <img className="kimsa-contact-icon" src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/livechat.png" alt="LiveChat" />
                        <div className="kimsa-contact-text">
                            <span className="kimsa-contact-title">Liên hệ</span>
                        </div>
                    </a>

              
                    {/* Email */}
                    <a href="mailto:info@kimsa88.com" className="kimsa-contact-item">
                        <img className="kimsa-contact-icon" src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/mail.png" alt="Mail" />
                        <div className="kimsa-contact-text">
                            <span className="kimsa-contact-title">E-mail</span>
                            <span className="kimsa-contact-desc">info@kimsa88.net</span>
                        </div>
                    </a>
                    <div style={{ height: "1px", background: "rgba(255,255,255,0.3)", margin: "5px 0" }}></div>

                  

                    {/* Tải App */}
                    {setting?.down_link && (
                        <a href={setting.down_link} target="_blank" rel="noreferrer" className="kimsa-contact-item">
                            <div style={{ width: "30px", textAlign: "center", fontWeight: "bold", color: "#fff" }}>APP</div>
                            <div className="kimsa-contact-text">
                                <span className="kimsa-contact-title">Tải App Về Máy</span>
                            </div>
                        </a>
                    )}
                </div>
            </div>


            {/* FOOTER CHÍNH BÊN DƯỚI (GIỮ NGUYÊN) */}
            <footer id="footer" className="app-footerr">
                <div className="guide-sub-bar">
                    <div className="container">
                        <ul>
                            <li>
                                <a href="#">Làm thế nào để đăng ký</a>
                            </li>
                            <li>
                                <a href="#">Cách gửi tiền</a>
                            </li>
                            <li>
                                <a href="#">Cách rút tiền</a>
                            </li>
                            <li>
                                <a href="#">Cách chuyển</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="container">
                    <div className="footer-content">
                        <div className="footer-left-content">
                            <h2>Về KIM SA</h2>
                            <p>KIM SA được thành lập với sứ mệnh đơn giản là trở thành sòng bạc trực tuyến tốt nhất ở Thái Lan, thổi sức sống và niềm vui mới vào thế giới giải trí sòng bạc ảo.</p>
                            <br />
                            <p>Mang đến cho bạn những trò chơi hay nhất từ ​​các nhà cung cấp đẳng cấp thế giới và dịch vụ đáng tin cậy chưa từng có ở mức độ cao, bạn sẽ có trải nghiệm tuyệt vời về những trò chơi hay nhất này.</p>
                        </div>
                        <div className="footer-right-content">
                            <h2>Thế giới của KIM SA</h2>
                            <div className="footer-text-wrapper">
                                <div className="footer-text-content">
                                    <h4>KIM SA</h4>
                                    <ul>
                                        <li>
                                            <a href="#">VỀ CHÚNG TÔI</a>
                                        </li>
                                        <li>
                                            <a href="#">liên kết</a>
                                        </li>
                                        <li>
                                            <a href="#">Ngân hàng</a>
                                        </li>
                                        <li>
                                            <a href="#">Khuyến mãi</a>
                                        </li>
                                        <li>
                                            <a href="#">Ủng hộ</a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="footer-text-content">
                                    <h4>Trung tâm thông tin</h4>
                                    <ul>
                                        <li>
                                            <a href="#">Trách nhiệm</a>
                                        </li>
                                        <li>
                                            <a href="#">Chính sách bảo mật</a>
                                        </li>
                                        <li>
                                            <a href="#">FAQ</a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="footer-text-content">
                                    <h4>Phương thức thanh toán</h4>
                                    <div className="payment-img">
                                        <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/bank/1.png" alt="" />
                                        <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/bank/2.png" alt="" />
                                        <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/bank/3.png" alt="" />
                                        <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/bank/4.png" alt="" />
                                        <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/bank/5.png" alt="" />
                                        <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/bank/6.png" alt="" />
                                        <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/bank/7.png" alt="" />
                                        <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/bank/8.png" alt="" />
                                        <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/bank/9.png" alt="" />
                                    </div>
                                </div>
                                <div className="footer-text-content">
                                    <div className="contact-wrapper">
                                        <h4>LIÊN HỆ</h4>
                                        <div className="contact-img">
                                            <a href="tel:0393700642" target="_blank" rel="noreferrer">
                                                <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/phone.png" alt="" />
                                            </a>
                                            <a href="#" target="_blank" rel="noreferrer">
                                                <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/facebook.png" alt="" />
                                            </a>
                                            <a href="https://t.me/kimsa88_1bot" target="_blank" rel="noreferrer">
                                                <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/tele.png" alt="" />
                                            </a>
                                            <a href="#" target="_blank" rel="noreferrer">
                                                <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/zalo.png" alt="" />
                                            </a>
                                            <a href="mailto:info@kimsa88.com" target="_blank" rel="noreferrer">
                                                <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/email.png" alt="" />
                                            </a>
                                        </div>
                                    </div>
                                    <div className="suggested-browser">
                                        <h4>Trình duyệt được đề xuất</h4>
                                        <div className="browser-img">
                                            <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/firefox.png" alt="" />
                                            <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/chrome.png" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="povider-hover-group">
                    <div className="povider-wrapper">
                        <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/provider.png" alt="" />
                        <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/provider2.png" alt="" />
                    </div>
                    <div className="copyright">© 2019 kimsa888.com:6001 . All rights reserved for those aged 18+</div>
                </div>
            </footer>
        </>
    );
}
export default Footer;